import React from 'react';
import CompanionIcon from '../../../images/companionIcon.svg';
import useStore from '../../../Store/Store';
import { capitalize, isEmpty } from 'lodash';
import { getActivityApi, getRecipientActivityApi } from '../../../utils/api';
import { useQuery } from 'react-query';

export default function CompanionCard() {
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);
  const deviceActivities = useStore((state) => state.deviceActivities);
  const selectedRecipient = useStore((state) => state.selectedRecipient);
  const [text, setText] = React.useState('');

  const { isLoading } = useQuery(
    ['getActivityApi', selectedRecipient],
    () => {
      if (isEmpty(selectedRecipient)) {
        return getActivityApi({ userId: user?._id || user?.id });
      } else {
        return getRecipientActivityApi({ userId: user?._id || user?.id, recipientId: selectedRecipient });
      }
    },
    {
      retry: false,
      cacheTime: 0,
      onSuccess: ({ data }) => {
        setText(data?.text);
      },
      onError: (error) => {
        console.log('Error fetching activity data:', error);
      },
    },
  );

  return (
    <div className="main-container can-companion-card">
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '352px',
          padding: '24px 24px 24px 24px',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexWrap: 'nowrap',
          backgroundColor: '#ffffff',
          position: 'absolute',
          top: '0',
          left: '0',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            display: 'flex',
            minWidth: '0',
            flexDirection: 'column',
            gap: '24px',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            flexShrink: '0',
            flexWrap: 'nowrap',
            position: 'relative',
            zIndex: '1',
          }}
        >
          <div
            style={{
              display: 'flex',
              width: '240px',
              gap: '8px',
              alignItems: 'center',
              flexShrink: '0',
              flexWrap: 'nowrap',
              position: 'relative',
              zIndex: '2',
            }}
          >
            <div
              style={{
                width: '24px',
                height: '24px',
                flexShrink: '0',
                position: 'relative',
                overflow: 'hidden',
                zIndex: '3',
              }}
            >
              <img
                style={{
                  width: '21.306px',
                  height: '22.796px',
                  backgroundPosition: 'center',
                  backgroundSize: '100% 100%',
                  backgroundRepeat: 'no-repeat',
                  position: 'relative',
                  zIndex: '4',
                  margin: '0.6px 0 0 1.348px',
                }}
                src={CompanionIcon}
                alt="companion"
              />
            </div>
            <span
              style={{
                height: '28px',
                flexShrink: '0',
                flexBasis: 'auto',
                fontFamily: 'Roboto, var(--default-font-family)',
                fontSize: width > 1400 ? '20px' : '16px',
                fontWeight: '500',
                lineHeight: '28px',
                color: '#1d1d1f',
                position: 'relative',
                textAlign: 'left',
                whiteSpace: 'nowrap',
                zIndex: '5',
              }}
            >
              CAN Companion report
            </span>
          </div>
          <div
            style={{
              display: 'flex',
              height: '172px',
              flexDirection: 'column',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              alignSelf: 'stretch',
              flexShrink: '0',
              flexWrap: 'nowrap',
              backgroundColor: '#ffffff',
              borderRadius: '16px',
              position: 'relative',
              zIndex: '6',
            }}
          >
            <span
              style={{
                display: 'flex',
                width: 'auto',
                height: '66px',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                flexShrink: '0',
                fontFamily: 'Roboto, var(--default-font-family)',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '22px',
                color: '#1d1d1f',
                position: 'relative',
                textAlign: 'left',
                zIndex: '7',
              }}
            >
              {text}
            </span>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                flexShrink: '0',
                flexWrap: 'nowrap',
                position: 'relative',
                zIndex: '8',
              }}
            >
              {Object.entries(deviceActivities || {}).map(([key, value], idx) => (
                <div
                  style={{
                    display: 'flex',
                    gap: '4px',
                    alignItems: 'flex-start',
                    alignSelf: 'stretch',
                    flexShrink: '0',
                    flexWrap: 'nowrap',
                    position: 'relative',
                    zIndex: '9',
                    marginTop: '12px',
                  }}
                  key={idx}
                >
                  <span
                    style={{
                      height: '22px',
                      flexShrink: '0',
                      flexBasis: 'auto',
                      fontFamily: 'Roboto, var(--default-font-family)',
                      fontSize: '14px',
                      fontWeight: '400',
                      lineHeight: '22px',
                      color: '#59595f',
                      position: 'relative',
                      textAlign: 'left',
                      whiteSpace: 'nowrap',
                      zIndex: '10',
                    }}
                  >
                    {capitalize(key)}
                  </span>
                  <div
                    style={{
                      height: '22px',
                      flexGrow: '1',
                      flexShrink: '0',
                      flexBasis: '0',
                      position: 'relative',
                      overflow: 'hidden',
                      zIndex: '11',
                    }}
                  >
                    <div
                      style={{
                        width: '201px',
                        height: '1px',
                        backgroundPosition: 'center',
                        backgroundImage: 'url(/images/939b09ef-61d2-496f-b8e1-70e59b877532.png)',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        position: 'relative',
                        zIndex: '12',
                        margin: '15px 0 0 0',
                      }}
                    />
                  </div>
                  <span
                    style={{
                      height: '22px',
                      flexShrink: '0',
                      flexBasis: 'auto',
                      fontFamily: 'Roboto, var(--default-font-family)',
                      fontSize: '14px',
                      fontWeight: '500',
                      lineHeight: '22px',
                      color: '#1d1d1f',
                      position: 'relative',
                      textAlign: 'left',
                      whiteSpace: 'nowrap',
                      zIndex: '13',
                    }}
                  >
                    {value || 0}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* <button
          style={{
            display: 'flex',
            minWidth: '0',
            height: '40px',
            padding: '7.996px 16px 7.996px 16px',
            gap: '8px',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'stretch',
            flexShrink: '0',
            flexWrap: 'nowrap',
            borderRadius: '100px',
            border: '1px solid #e5e5ea',
            position: 'relative',
            zIndex: '24',
            cursor: 'pointer',
            background: 'transparent',
          }}
        >
          <span
            style={{
              height: '22px',
              flexShrink: '0',
              flexBasis: 'auto',
              fontFamily: 'Roboto, var(--default-font-family)',
              fontSize: '14px',
              fontWeight: '500',
              lineHeight: '22px',
              color: '#1d1d1f',
              position: 'relative',
              textAlign: 'left',
              whiteSpace: 'nowrap',
              zIndex: '25',
            }}
          >
            See Health overview
          </span>
          <div
            style={{
              width: '20px',
              height: '20px',
              flexShrink: '0',
              position: 'relative',
              zIndex: '26',
            }}
          >
            <ArrowOutwardIcon style={{ fontSize: '20px' }} />
          </div>
        </button> */}
        <div
          style={{
            width: '372px',
            height: '352px',
            flexShrink: '0',
            borderRadius: '20px',
            position: 'absolute',
            top: '0',
            left: '0',
            filter: 'blur(6.55px)',
            zIndex: '28',
          }}
        />
        <div
          style={{
            width: '372px',
            height: '352px',
            flexShrink: '0',
            borderRadius: '20px',
            position: 'absolute',
            top: '0',
            left: '0',
            filter: 'blur(12.5px)',
            zIndex: '29',
          }}
        />
        <div
          style={{
            width: '372px',
            height: '352px',
            flexShrink: '0',
            borderRadius: '20px',
            position: 'absolute',
            top: '0',
            left: '0',
            filter: 'blur(1px)',
            zIndex: '30',
          }}
        />
        <div
          style={{
            width: '372px',
            height: '352px',
            flexShrink: '0',
            borderRadius: '20px',
            position: 'absolute',
            top: '0',
            left: '0',
            filter: 'blur(1.5px)',
            zIndex: '31',
          }}
        />
      </div>
    </div>
  );
}
